import { useState } from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { CheckboxListProps } from './types';

export const CheckboxList: React.FC<CheckboxListProps> = ({
  disableRipple,
  dataTestId,
  isDense,
  isReadOnly,
  options,
  listSx,
  disableGutters,
  listItemButtonSx,
  listItemIconSx,
  onChange,
  defaultValue = [],
}) => {
  const [checked, setChecked] = useState(defaultValue);

  const handleToggle = (title: string) => () => {
    const currentIndex = checked.indexOf(title);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(title);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    const selectedTitles = options
      .filter((option) => newChecked.includes(option.title))
      .map((option) => option.title);
    onChange(selectedTitles);
  };

  return (
    <List sx={listSx} data-testid={dataTestId}>
      {options?.map((option) => {
        return (
          <ListItem key={option.id} disableGutters={disableGutters}>
            <ListItemButton
              disableRipple={disableRipple}
              onClick={isReadOnly ? null : handleToggle(option.title)}
              dense={isDense}
              sx={listItemButtonSx}
            >
              <ListItemIcon sx={listItemIconSx}>
                <Checkbox
                  edge="start"
                  checked={checked.includes(option.title) || option.isChecked}
                  tabIndex={-1}
                  disabled={isReadOnly}
                  data-testid={`checkbox-list-checkbox-${option.id}`}
                />
              </ListItemIcon>
              <ListItemText primary={option.title} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};
